import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { signup } from "../service/auth.servide";
import ReactGA from "react-ga4";

import { globalT } from "../utils/globalUtils.js";

export const RegisterForm = () => {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const [passRequisits, setPassRequisits] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);

  const [postErrors, setPostErrors] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    repeatPassword: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (formData.password !== formData.repeatPassword) {
      setPostErrors("Las contraseñas no coindicen");
    } else if (isChecked === false) {
      setPostErrors("Debes aceptar las políticas generales");
    } else {
      document.querySelector(".m-userform").classList.add("loading");

      try {
        await signup(formData);
        document.querySelector(".m-userform").classList.remove("loading");

        ReactGA.event({
          category: "Usuario",
          action: "Crear nuevo registro",
        });

        navigate("/login");
      } catch (e) {
        document.querySelector(".m-userform").classList.remove("loading");

        e.response && setPostErrors(e.response.data.message);
      }
    }
  };

  return (
    <div className="m-userform">
      <div className="m-title">{globalT("Regístrate")}</div>
      <div className="m-subtitle">
        {globalT("Rellena estos campos para registrarte en nuestra app")}
      </div>
      <form className="m-form main-form">
        <div className="m-input-group">
          <label>{globalT("Nombre")} *</label>
          <input
            type="text"
            name="username"
            required
            placeholder={globalT("Escribe aquí tu nombre")}
            value={formData.nombre}
            onChange={handleInputChange}
          />
        </div>
        <div className="m-input-group">
          <label>Email *</label>
          <input
            required
            type="email"
            name="email"
            placeholder={globalT("Escribe aquí tu email")}
            value={formData.email}
            onChange={handleInputChange}
          />
        </div>
        <div className="m-input-group">
          {" "}
          <div className="m-eye" onClick={togglePasswordVisibility}></div>
          <label>
            {globalT("Contraseña")} *{" "}
            <span className="prereq">
              (1 {globalT("mayúscula")} y 6 {globalT("letras")})
            </span>
          </label>
          <input
            required
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder={
              passRequisits
                ? `1 ${globalT("mayúscula")} ${globalT("y")} 6 ${globalT(
                    "letras"
                  )}`
                : globalT("Escribe aquí tu contraseña")
            }
            value={formData.password}
            onChange={handleInputChange}
            onFocus={setPassRequisits}
          />
        </div>
        <div className="m-input-group">
          <div className="m-eye" onClick={togglePasswordVisibility}></div>{" "}
          <label>{globalT("Repite tu password")}</label>
          <input
            required
            type={showPassword ? "text" : "password"}
            name="repeatPassword"
            placeholder={
              passRequisits
                ? `1 ${globalT("mayúscula")} ${globalT("y")} 6 ${globalT(
                    "letras"
                  )}`
                : globalT("Escribe aquí tu contraseña")
            }
            value={formData.repeatPassword}
            onChange={handleInputChange}
          />
        </div>
        <div className="m-switch-group">
          <label
            className={`switch ${isChecked ? "checked" : ""}`}
            htmlFor="agreement"
          >
            <input
              type="checkbox"
              id="agreement"
              onChange={() => setIsChecked(!isChecked)}
              checked={isChecked}
              required
            />
            <span className="slider"></span>
          </label>

          <span>
            {globalT("Acepto la")}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://descargas.uned.es/publico/pdf/Aviso_Legal_UNED.pdf"
            >
              {" "}
              {globalT("nota legal")}
            </a>
            ,{" "}
            <a target="_blank" rel="noreferrer" href="/privacy.html">
              {globalT("política de privacidad")}{" "}
            </a>
            {globalT("y la")}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.uned.es/universidad/inicio/informacion-cookies.html"
            >
              {" "}
              {globalT("política de cookies")}
            </a>
          </span>
        </div>{" "}
        <div className="m-switch-group">
          <label
            className={`switch ${isChecked2 ? "checked" : ""}`}
            htmlFor="newsletter"
          >
            <input
              type="checkbox"
              id="newsletter"
              onChange={() => setIsChecked2(!isChecked2)}
              checked={isChecked2}
            />
            <span className="slider"></span>
          </label>{" "}
          <span>
            {globalT(
              "Acepto recibir información sobre promociones, novedades etc"
            )}{" "}
          </span>
        </div>
        <div className="m-link">
          {postErrors && <div className="m-error">{postErrors}</div>}
          {globalT("¿Ya eres usuario de Rewrite?")}
          <Link to="/login"> {globalT("Accede aquí")}</Link>
        </div>
        <button className="m-button" type="submit" onClick={handleSubmit}>
          {globalT("Enviar")}
        </button>
      </form>
    </div>
  );
};
